import { AllyBase } from "./base";

/**
 * This class provides unique ids.
 * 
 * @extends AllyBase
 */
export class AllyId extends AllyBase {
    /**
     * From this baseId new ids for the AllyId objects are derived.
     */
    private static baseId: number = 0;
    /**
     * The list of ids that were returnd by AllyId objects.
     */
    private static returnedIds: number[] = [];

    /**
     * Initialises the provided AllyId object.
     * @param object The object to be initialised.
     */
    private static initId(object: AllyId) {
        object.destroyer.addCallback(() => {
            AllyId.returnId(object.id);
        });
        if (AllyId.returnedIds.length > 0) {
            object.id = AllyId.returnedIds.pop()!;
        } else {
            object.id = AllyId.baseId;
            AllyId.baseId += 1;
        }
    }

    /**
     * Return an id to the list of returned ids for the AllyId objects.
     * 
     * When createing new ids for AllyId objects the ids in said list will be used.
     * @param id The id to be returned.
     */
    private static returnId(id: number) {
        AllyId.returnedIds.push(id);
    }

    /**
     * This objects id, created by AllyId["initId"].
     */
    private id: number;
    /**
     * From this baseId new ids generated by this AllyId object are derived.
     */
    private baseId: number;
    /**
     * The list of ids that were returnd to this AllyId object.
     */
    private returnedIds: string[];
    /**
     * The prefix used by this AllyId object when generating new ids.
     */
    private prefix: string;

    /**
     * @param prefix This will be the prefix for the ids generated by this object.
     * @param bridge The bridge to the parent in the hierarchical tree.
     * @see AllyBase
     */
    constructor(prefix: string, bridge: () => AllyBase) {
        super(bridge);
        this.id = null as unknown as number;
        AllyId.initId(this);
        this.baseId = 0;
        this.returnedIds = [];
        this.prefix = prefix;
        if (this.prefix !== "") {
            this.prefix = this.prefix + "-";
        }
    }

    /**
     * Generates a unique id.
     * 
     * If ids that were returnd via AllyId["returnId"] are available then one of those ids will be used otherwise a new id will be generated.
     * 
     * Use the function AllyId["returnId"] to return the ids generated by this function once they are no longer needed. 
     * @returns Returns the id.
     */
    public getId() {
        if (this.returnedIds.length > 0) {
            return this.returnedIds.shift()!;
        } else {
            let id: string = "_adx-ally-" + this.prefix + this.id.toString() + "-" + this.baseId.toString();
            this.baseId += 1;
            return id;
        }
    }

    /**
     * Return an id to the list of returned ids of this AllyId object.
     * 
     * When new ids are created by this AllyId object the ids in said list will be used.
     * @param id The id to be returned.
     */
    public returnId(id: string) {
        this.returnedIds.push(id);
    }
}